import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from '@pages/admin-pages/admin-routing.module';
import {
  UserManagementComponent
} from '@pages/index.pages';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Components from ng-bootstrap.github.io
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ComponentsModule } from '@components/components.module';
import { AppointmentsPage } from '@src/app/pages/admin-pages/consultant-pages/appointments/appointments.page';

// Services
import {
  DialogService
} from "@services/auth-guard/dialog.service";
import { LoginAttempsComponent } from '@pages/admin-pages/reports/login-attemps/login-attemps.page';
import { DatabaseLogsComponent } from '@pages/admin-pages/reports/database-logs/database-logs.page';
import { DatabaseResourcesMenuComponent } from './database-resources/database-resources-menu.component';
import { ReportsMenuComponent } from '@pages/admin-pages/reports/reports-menu.component';
import { PortalConfigurationMenuComponent } from '@pages/admin-pages/portal-configuration/portal-configuration-menu.component';
import { HospitalsPage } from './database-resources/hospitals/hospitals.page';
import { DepartmentsPage } from './database-resources/departments/departments.page';
import { PayorsPage } from './database-resources/payors/payors.page';
import { ConsultantsPage } from './database-resources/consultants/consultants.page';
import { EditConsultantPage } from './database-resources/consultants/edit-consultant/edit-consultant.page';
import { SubdepartmentsPage } from './database-resources/subdepartments/subdepartments.page';
import { DeletedUsersPage } from '@src/app/pages/admin-pages/reports/deleted-users/deleted-users.page';
import { RegisteredUsersPage } from '@src/app/pages/admin-pages/reports/registered-users/registered-users.page';
import { ToolsMenuComponent } from '@src/app/pages/admin-pages/tools/tools-menu.component';

import { CalendarModule } from 'primeng/calendar';
import { TabMenuModule } from 'primeng/tabmenu';

import { BookedAppointmentsComponent } from './consultant-pages/components/booked-appointments/booked-appointments.component';
// import { ConfigurationPage } from './database-resources/configuration/configuration.page';
import { ClearCachePage } from './tools/clear-cache/clear-cache.page';

import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { PortalParametersPage } from './portal-configuration/portal-parameters/portal-parameters.page';
import { FaqsPage } from './portal-configuration/faqs/faqs.page';
import { FilterFaqsByLanguagePipe } from '../../pipes/filter-by-language.pipe';
import { GetActivesPipe } from '../../pipes/get-actives.pipe';
import { SearchfilterPipe } from '../../pipes/search-filter.pipe';
import { PinGeneratorPage } from './tools/pin-generator/pin-generator.page';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    AdminRoutingModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    BsDatepickerModule,
    CalendarModule,
    TabMenuModule,
    TableModule, // Added DataTableModule
    PaginatorModule //  Added PaginatorModule
  ],
  declarations: [
    UserManagementComponent,
    LoginAttempsComponent,
    DatabaseLogsComponent,
    DatabaseResourcesMenuComponent,
    ReportsMenuComponent,
    PortalConfigurationMenuComponent,
    HospitalsPage,
    DepartmentsPage,
    SubdepartmentsPage,
    PayorsPage,
    ConsultantsPage,
    EditConsultantPage,
    AppointmentsPage,
    BookedAppointmentsComponent,
    // ConfigurationPage,
    ClearCachePage,
    DeletedUsersPage,
    RegisteredUsersPage,
    PortalParametersPage,
    FaqsPage,
    FilterFaqsByLanguagePipe,
    GetActivesPipe,
    SearchfilterPipe,
    ToolsMenuComponent,
    PinGeneratorPage
  ],
  providers: [
    DialogService
  ],
  exports: [
    FilterFaqsByLanguagePipe,
    GetActivesPipe
  ],
})
export class AdminModule { }
